import { v4 as uuidv4 } from 'uuid';

export class Card {
    public readonly cardProductId: number;
    public readonly cardNo: string;
    public readonly cardName: string;
    public readonly canFavorite: boolean;

    /**
     * このオブジェクトの生成時に自動付与されるUUID
     */
    public readonly uuid: string;

    constructor(
        cardProductId: number,
        cardNo: string,
        cardName: string,
        canFavorite: boolean) {
        this.cardProductId = cardProductId;
        this.cardNo = cardNo;
        this.cardName = cardName;
        this.canFavorite = canFavorite;
        this.uuid = uuidv4();
    }

    static parseCard(obj: string) {
        if (!obj) {
            throw Error('object is empty.');
        }

        const dirtyItem = JSON.parse(obj);

        const card = new Card(
            Number.parseInt(dirtyItem.cardProductId),
            dirtyItem.cardNo ?? "",
            dirtyItem.cardName ?? "",
            (dirtyItem.canFavorite === undefined || dirtyItem.canFavorite === true || dirtyItem.canFavorite === 1),
        );
        if (!card.cardName || !card.cardNo || !Number.isInteger(card.cardProductId)) {
            console.error(card);
            throw Error('validate failed.');
        }

        return card;
    }


    public get url(): string {
        let prefix = '';
        if (window.location.hostname === 'localhost') {
            prefix = 'http://localhost/osica-member';
        } else {
            prefix = '/member';
        }

        return prefix + `/api/cardapi/image/${this.cardProductId}/${this.cardNo}`;
    }

    public isEqual(card?: Card) {
        if (card) {
            return this.cardProductId === card.cardProductId
                && this.cardNo === card.cardNo;
        }
        return false;
    }

    public convertToSerializableCard(): SerializableCard {
        return {
            cardName: this.cardName,
            cardNo: this.cardNo,
            cardProductId: this.cardProductId,
            canFavorite: this.canFavorite
        };
    }

    static loadFromSerializableCard(card: SerializableCard) {
        return new Card(card.cardProductId, card.cardNo, card.cardName, card.canFavorite === undefined || card.canFavorite === true);
    }
}

export interface SerializableCard {
    cardProductId: number;
    cardNo: string;
    cardName: string;
    canFavorite?: boolean;
}